export function app(options) {
  // When building with navi-scripts, the `global.NaviApp` object will be
  // injected with a value of { isBuild: true }
  var global = window;
  var app = global.NaviApp;

  if (!app) {
    app = global.NaviApp = {};
  }

  Object.assign(app, options);

  if (!app.isBuild) {
    options.main();
  }
}
export function getApp() {
  var global = window;
  return global.NaviApp || {};
}